import React from 'react';
import { IconProps } from '../../../../../src/features/common/types/common';

function BlackTree({ color = '#4d5153' }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.502"
      height="19.747"
      viewBox="0 0 16.502 19.747"
    >
      <g fill={color} data-name="Group 642">
        <path
          d="M270.307 593.327v5.7h-1.759v-5.055l-1.955-1.855-.263-.263.546-1.354 2.018 1.973a27.631 27.631 0 00-.3-4.209l.981-.873s.527 3.137.573 3.318c0 0 .1.118.236-.073l.982-1.391.854.846z"
          data-name="Path 690"
          transform="translate(-260.968 -579.464)"
        ></path>
        <path
          d="M260.967 567.264a7.933 7.933 0 108.251 7.927 8.094 8.094 0 00-8.251-7.927zm-.058 14.4a6.449 6.449 0 116.777-6.441 6.615 6.615 0 01-6.777 6.44z"
          data-name="Path 691"
          transform="translate(-252.716 -567.264)"
        ></path>
        <ellipse
          cx="0.88"
          cy="0.184"
          data-name="Ellipse 119"
          rx="0.88"
          ry="0.184"
          transform="translate(7.58 19.38)"
        ></ellipse>
      </g>
    </svg>
  );
}

export default BlackTree;
